var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageTagsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1023_11096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1071 12.7531L13.0537 3.69978C12.9332 3.58142 12.7905 3.48809 12.6337 3.42516C12.477 3.36223 12.3093 3.33094 12.1404 3.33311H10.7471L21.1671 13.6331L14.1471 20.7131C14.2666 20.8326 14.4084 20.9275 14.5646 20.9922C14.7207 21.0569 14.8881 21.0902 15.0571 21.0902C15.2261 21.0902 15.3934 21.0569 15.5496 20.9922C15.7057 20.9275 15.8476 20.8326 15.9671 20.7131L22.1071 14.5731C22.2266 14.4536 22.3214 14.3118 22.3861 14.1556C22.4508 13.9995 22.4841 13.8321 22.4841 13.6631C22.4841 13.4941 22.4508 13.3267 22.3861 13.1706C22.3214 13.0145 22.2266 12.8726 22.1071 12.7531Z",
    fill: "#2E3978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20698 8.31337C5.69667 8.31337 6.09365 7.9164 6.09365 7.42671C6.09365 6.93701 5.69667 6.54004 5.20698 6.54004C4.71729 6.54004 4.32031 6.93701 4.32031 7.42671C4.32031 7.9164 4.71729 8.31337 5.20698 8.31337Z",
    fill: "#2E3978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5201 12.7797L9.46678 3.71967C9.34792 3.5977 9.20592 3.50068 9.04909 3.43428C8.89226 3.36789 8.72376 3.33346 8.55345 3.33301H2.40678C2.06554 3.33301 1.73827 3.46857 1.49697 3.70986C1.25568 3.95116 1.12012 4.27843 1.12012 4.61967V10.7663C1.12058 10.9351 1.15439 11.102 1.2196 11.2576C1.28482 11.4132 1.38015 11.5544 1.50012 11.673L10.5601 20.733C10.6796 20.8525 10.8215 20.9474 10.9776 21.0121C11.1337 21.0768 11.3011 21.1101 11.4701 21.1101C11.6391 21.1101 11.8065 21.0768 11.9626 21.0121C12.1188 20.9474 12.2606 20.8525 12.3801 20.733L18.5201 14.593C18.7595 14.352 18.8938 14.026 18.8938 13.6863C18.8938 13.3466 18.7595 13.0207 18.5201 12.7797ZM11.5068 19.793L2.46012 10.7663V4.66634H8.52678L17.5801 13.653L11.5068 19.793Z",
    fill: "#2E3978"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1023_11096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageTagsIcon);
export default __webpack_public_path__ + "static/media/ManageTagsIcon.180769534fa0c01190dde036ac3a31f2.svg";
export { ForwardRef as ReactComponent };